export const isAudit = (item: Audit | Video | Image): item is Audit => {
  return item.type === 'audit';
};
